export function enableRegistrationInput({ value }) {
  return ['FIRST_REGISTRATION', 'ALREADY_REGISTERED_WITH_REGISTRATION'].includes(value);
}
